export enum Environement {
  LOCAL = 'local',
  DEV = 'dev',
  STAGING = 'staging',
  PROD = 'prod',
}

export enum EnvironmentContext {
  LIVE = 'live',
  PREVIEW = 'preview',
}
